var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "translate(1 21)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#A9C7D8",
    strokeLinecap: "square",
    d: "M1,26 L56.0090902,26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#49A25A",
    stroke: "#49A25A",
    strokeLinecap: "round",
    d: "M0,11.5829451 L11.8845968,1.44021509e-12 L31.6546841,6.82121026e-13 L39.2181462,9.31293561 L55.011955,11.3291538 C56.1099219,11.4693189 56.7013807,12.4267805 56.3342028,13.4643484 L54,20.0603157 L4,20.0603157 L0,11.5829451 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 21,
    r: 5,
    fill: "#618287",
    stroke: "#456782",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 21,
    r: 5,
    fill: "#618287",
    stroke: "#456782",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFDC82",
    strokeLinecap: "square",
    d: "M8,10 L34,10"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarIcon);
export default __webpack_public_path__ + "static/media/carIcon.487afc537d7a13a13544e24cdeb0ffba.svg";
export { ForwardRef as ReactComponent };